export default __webpack_public_path__ + "static/media/eraser.dec3b5cc.webp";